import React, { useRef } from "react";
import axios from "axios";
import "../UKDestination/Ukdestinationpage.css";
import LandingForm from "../Shared/Landingform";
import { Helmet } from "react-helmet-async";
/* ─────────────────────────────────────────────
   DATA CONSTANTS
───────────────────────────────────────────── */
const STATS = [
  { num: "150+",   lbl: "UK Universities" },
  { num: "2 Yrs",  lbl: "Post-Study Work Visa" },
  { num: "£8,000", lbl: "Deposits From" },
  { num: "98%",    lbl: "Visa Success Rate" },
];

const CITIES = [
  { name: "London",     img: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&q=80" },
  { name: "Manchester", img: "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?w=600&q=80" },
  { name: "Coventry",   img: "https://images.unsplash.com/photo-1564594985645-4427056e22e2?w=600&q=80" },
];

const UNIVERSITIES = [
  "CU Coventry",
  "University of Roehampton",
  "University of Greenwich",
  "University of Law",
  "University of Winchester",
  "Ulster University",
];

const VISA_STEPS = [
  {
    num: 1,
    title: "CAS Letter",
    desc: "Once you accept your offer and pay your deposit, the university issues your Confirmation of Acceptance for Studies.",
  },
  {
    num: 2,
    title: "Financial Documents",
    desc: "We help you prepare bank statements or loan sanction letters meeting UKVI's exact requirements.",
  },
  {
    num: 3,
    title: "Visa Application",
    desc: "We guide you through the online Student Route visa application and biometrics appointment.",
  },
  {
    num: 4,
    title: "Pre-Departure Briefing",
    desc: "Accommodation, banking, and what to pack — we prepare you for arrival.",
  },
];

const FAQS = [
  {
    q: "Can I work while studying in the UK?",
    a: "Yes — most student visas allow up to 20 hours/week during term time and full-time during holidays.",
  },
  {
    q: "How much does it cost to live in the UK?",
    a: "Outside London, budget roughly £900–£1,200/month for accommodation, food, and transport. London runs higher.",
  },
  {
    q: "Do I need IELTS?",
    a: "Most universities accept IELTS 6.0–6.5, though some accept Duolingo or PTE. We'll confirm exact requirements for your course.",
  },
];

// const FORM_FIELDS = [
//   { name: "name",     label: "Full Name",       type: "text",   placeholder: "Enter your full name",  required: true },
//   { name: "email",    label: "Email",            type: "email",  placeholder: "you@email.com",          required: true },
//   { name: "phone",    label: "Phone / WhatsApp", type: "phone",  required: true },
//   {
//     name: "stream",
//     label: "Course Interest",
//     type: "select",
//     placeholder: "Select stream",
//     options: [
//       "Business & Management",
//       "Computer Science / IT",
//       "Engineering",
//       "Healthcare & Medicine",
//       "Design & Creative Arts",
//       "Law",
//       "Other",
//     ],
//   },
//   {
//     name: "level",
//     label: "Study Level",
//     type: "select",
//     placeholder: "Select level",
//     options: [
//       "Pre-sessional English",
//       "Foundation",
//       "Bachelors Degree",
//       "Masters Degree",
//       "PHD",
//       "DBA",
//     ],
//   },
// ];
const FORM_FIELDS = [
  { name: "name",     label: "Full Name",       type: "text",   placeholder: "Enter your full name",  required: true },
  { name: "email",    label: "Email",            type: "email",  placeholder: "you@email.com",          required: true },
  { name: "phone",    label: "Phone / WhatsApp", type: "phone",  required: true },
  {
    name: "stream",
    label: "Course Interest",
    type: "text",
    placeholder: "e.g. Computer Science, MBA, Business Management",
    required: true,
  },
  {
    name: "level",
    label: "Study Level",
    type: "select",
    placeholder: "Select level",
    options: [
      "Pre-sessional English",
      "Foundation",
      "Bachelors Degree",
      "Masters Degree",
      "PHD",
      "DBA",
    ],
  },
];
const CONSENT_ITEMS = [
  {
    id: "consent-marketing-uk",
    text: `I consent to receiving information (by email, phone, or SMS/WhatsApp) about UK courses and services from FlyUrDream, in line with the <a href="/privacy-policy">Privacy Policy</a>.`,
  },
  {
    id: "consent-whatsapp-uk",
    text: "I would like to receive WhatsApp updates on my application status and UK visa deadlines.",
  },
];

/* ─────────────────────────────────────────────
   COMPONENT
───────────────────────────────────────────── */
export default function UKDestinationPage({ logoSrc = "/logo.png" }) {
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // ── Submit: build Enquiry payload (same shape as LPGeneral/LoanLandingPage/
  // CollegeVisitCapture — wrapped under "enquiry" key, study_Level as plain
  // string) and CREATE it against the backend.
const handleSubmit = async (data) => {
  // TEMP DEBUG: check the browser console and inspect the exact keys/shape
  // LandingForm is sending, then remove this line once confirmed.
  console.log("Raw data from LandingForm:", JSON.stringify(data, null, 2));

  // Try a few likely key variants in case LandingForm uses different names
  const resolvedEmail = data.email || data.Email || "";
  const resolvedPhone =
    data.phone?.number ||
    data.phoneNumber ||
    data.mobile ||
    (typeof data.phone === "string" ? data.phone : "") ||
    "";
  const resolvedPhoneCode =
    data.phone?.code || data.countryCode || data.phoneCode || "+91";

  if (!resolvedEmail && !resolvedPhone) {
    console.error("Neither email nor phone resolved from form data:", data);
    throw new Error("Please provide at least an email or phone number.");
  }

const payload = {
  
    Enquiry_Id: null,
    CompanyId: {   CompanyID: window.location.origin === "https://flyurdream.com" ? 160 : 2,

            UCompanyId: window.location.origin === "https://flyurdream.com" ? "GuidP160" : "GuidP2",
 },

       UCompanyId: window.location.origin === "https://flyurdream.com" ? "GuidP160" : "GuidP2",
    FirstName: data.name || "",
    LastName: "",
    Mobile_Number: resolvedPhone,
    Country_Code: resolvedPhoneCode,
    Email: resolvedEmail,
    Preferred_Contact_Time: null,
    Lead_Type: { FieldType: "General" },
    Lead_Stage: { FieldType: "New" },
     Source:{

fieldType: "Manual"
  },

    Source_Company: "FlyUrDream",
    CollegeVisit_CollegeName: null,
    CollegeVisit_City: null,
    CollegeVisit_Date: null,
    Batch: "",
    Captured_By: null,
    Captured_By_System: "UKDestinationPage",
    Assigned_To: null,
    Converted_By: null,
    Converted_Application_Id: null,
    Is_Consented: Boolean(data["consent-marketing-uk"]),
    Consent_Via: data["consent-whatsapp-uk"] ? { FieldType: "WhatsApp" } : null,
    Consent_Financial_Share: null,
    Consent_WhatsAppUpdates: Boolean(data["consent-whatsapp-uk"]),
    Preferred_Country: null,
    Preferred_CountryName: "United Kingdom",
    Course_Interest: data.stream || "",
    Study_Level: data.level || "",
    University: null,
    University_Interest: "",
    Intake: null,
    Loan_Amount_Range: null,
    Has_Collateral: null,
    Notes: "",
    CreatedBy: null,
    IsArchived: false,
  
};

  console.log("Payload being sent:", payload);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/CreateEnquiry`,
      payload
    );
    console.log("Enquiry created:", response.data);
  } catch (error) {
    console.error("Enquiry submit failed:", error);
    throw error;
  }
};

  return (
    <div className="uk-page">
      {/* ── HEADER ── */}
      {/* <header className="lp-header" role="banner">
        <a href="/" className="lp-header__logos" aria-label="FlyUrDream home">
          <img
            className="lp-header__logo"
            src={logoSrc}
            alt="FlyUrDream"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        </a>
        <button className="lp-header__cta" onClick={scrollToForm}>
          Get Free Assessment
        </button>
      </header> */}
  <Helmet>
        <title>Study in the UK | FlyUrDream</title>
        <meta name="description" content="Apply to 150+ UK universities with FlyUrDream. Free counselling, 98% visa success rate, 2-year post-study work visa guidance." />
        <link rel="canonical" href="https://flyurdream.com/study-in-uk" />

        {/* Open Graph (WhatsApp/Facebook share preview) */}
        <meta property="og:title" content="Study in the UK | FlyUrDream" />
        <meta property="og:description" content="Free UK university assessment — 150+ partner universities, visa guidance included." />
        <meta property="og:image" content="https://flyurdream.com/assets/og-uk.jpg" />
        <meta property="og:url" content="https://flyurdream.com/study-in-uk" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {/* ── HERO ── */}
      <section className="uk-hero" aria-label="Hero">
        <div className="uk-hero__bg" role="img" aria-label="London skyline" />
        <div className="uk-hero__inner">
          <div className="uk-hero__badge">🇬🇧 2026 UK Intake Open</div>
          <h1 className="uk-hero__title">
            Study in the UK —<br />
            <span>your gateway to a global career.</span>
          </h1>
          <p className="uk-hero__sub">
            Shorter degrees, world-class universities, and a 2-year
            post-study work visa. FlyUrDream handles everything — free.
          </p>
          <div className="uk-hero__cta-row">
            <button className="uk-hero__btn" onClick={scrollToForm}>
              Get My Free UK Assessment →
            </button>
            <button className="uk-hero__btn-outline" onClick={scrollToForm}>
              Explore Universities
            </button>
          </div>
        </div>
      </section>

      {/* ── STAT STRIP ── */}
      <div className="uk-stat-strip" aria-label="Key statistics">
        <div className="uk-stat-strip__inner">
          {STATS.map((s) => (
            <div className="uk-stat" key={s.lbl}>
              <div className="uk-stat__num">{s.num}</div>
              <div className="uk-stat__lbl">{s.lbl}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── MAIN LAYOUT ── */}
      <div className="uk-layout">
        {/* ── CONTENT COLUMN ── */}
        <main className="uk-content-col">

          {/* Why the UK */}
          <section className="sec-block">
            <div className="sec-label">Why the UK</div>
            <h2>A degree that opens doors worldwide.</h2>
            <p>
              UK degrees are respected globally, courses are shorter than in the US
              (3 years for most Bachelor's), and the Graduate Route visa lets you work
              in the UK for 2 years after you finish — no job offer required at the
              time of application.
            </p>
            <div className="uk-split">
              <div className="uk-split__img">
                <img
                  src="https://images.unsplash.com/photo-1559762717-99c4ad24f5d1?w=800&q=80"
                  // alt="Students on a UK university campus"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              </div>
              <div className="uk-split__text">
                <h3>Campus Life That Feels Like Home</h3>
                <p>
                  Student unions, 200+ societies, and a diverse international
                  community — most UK campuses have dedicated international student
                  support from day one.
                </p>
              </div>
            </div>
          </section>

          {/* Top Student Cities */}
          <section className="sec-block">
            <div className="sec-label">Top Student Cities</div>
            <h2>Find your city.</h2>
            <div className="uk-city-grid">
              {CITIES.map((city) => (
                <div className="uk-city-card" key={city.name}>
                  <img src={city.img} alt={city.name} loading="lazy" />
                  <div className="uk-city-card__overlay">
                    <span className="uk-city-card__name">{city.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Partner Universities */}
          <section className="sec-block">
            <div className="sec-label">Partner Universities</div>
            <h2>Apply directly through FlyUrDream.</h2>
            <div className="uk-uni-strip" role="list">
              {UNIVERSITIES.map((uni) => (
                <div className="uk-uni-logo" key={uni} role="listitem">
                  {uni}
                </div>
              ))}
            </div>
          </section>

          {/* Visa Pathway */}
          <section className="sec-block">
            <div className="sec-label">Visa Pathway</div>
            <h2>Your Student Route visa, simplified.</h2>
            {VISA_STEPS.map((step) => (
              <div className="uk-visa-step" key={step.num}>
                <div className="uk-visa-step__num" aria-hidden="true">
                  {step.num}
                </div>
                <div>
                  <div className="uk-visa-step__title">{step.title}</div>
                  <div className="uk-visa-step__desc">{step.desc}</div>
                </div>
              </div>
            ))}
          </section>

          {/* Testimonial */}
          <section className="sec-block">
            <div className="sec-label">Student Story</div>
            <h2>Real outcomes from the UK.</h2>
            <figure className="uk-testimonial">
              <img
                className="uk-testimonial__photo"
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80"
                alt="Arjun Sharma"
                loading="lazy"
              />
              <figcaption>
                <blockquote className="uk-testimonial__quote">
                  "FlyUrDream helped me get into Coventry with a £2,000 scholarship
                  — and walked me through every visa document. My CAS came in 10 days."
                </blockquote>
                <div className="uk-testimonial__name">Arjun Sharma</div>
                <div className="uk-testimonial__meta">BSc Computer Science, CU Coventry</div>
              </figcaption>
            </figure>
          </section>

          {/* FAQs */}
          <section className="sec-block">
            <div className="sec-label">FAQs</div>
            <h2>UK study — common questions.</h2>
            {FAQS.map((faq, i) => (
              <div className="uk-faq-item" key={i}>
                <div className="uk-faq-item__q">{faq.q}</div>
                <div className="uk-faq-item__a">{faq.a}</div>
              </div>
            ))}
          </section>

        </main>

        {/* ── FORM SIDEBAR ── */}
       <aside ref={formRef} id="uk-form" className="uk-aside-sticky" aria-label="Free UK Assessment form">
          <LandingForm
            variant="teal"
            title="Get Your Free UK Assessment"
            subtitle="60 seconds · 100% free"
            fields={FORM_FIELDS}
            submitLabel="Get My Free UK Assessment →"
            trustLine="Your data is safe and never shared"
            consentItems={CONSENT_ITEMS}
            onSubmit={handleSubmit}
          />
        </aside>
      </div>

      {/* ── STICKY MOBILE CTA ── */}
      {/* <div className="uk-sticky-cta" aria-hidden="true">
        <button onClick={scrollToForm}>
          Get My Free UK Assessment →
        </button>
      </div> */}

      {/* ── FOOTER ── */}
      <footer className="uk-footer" role="contentinfo">
        FlyUrDream · Free overseas education counselling<br />
        <a href="/privacy-policy">Privacy Policy</a> ·{" "}
        <a href="/terms">Terms</a> ·{" "}
        <a href="mailto:study@flyurdream.com">study@flyurdream.com</a>
      </footer>
    </div>
  );
}